import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import Layout from './components/Layout/Layout';
import RejectionNotices from './components/Common/RejectionNotices';
import Dashboard from './pages/Dashboard';
import EmployeeDashboard from './pages/EmployeeDashboard';
import EmployerDashboard from './pages/EmployerDashboard';
import AdminDashboard from './pages/AdminDashboard';
import AdminCVManagement from './pages/AdminCVManagement';
import AdminCVTemplateManagement from './pages/AdminCVTemplateManagement';
import AdminServicePrices from './pages/AdminServicePrices';
import AdminCompanyManagement from './pages/AdminCompanyManagement';
import CompaniesPage from './pages/CompaniesPage';
import JobsPage from './pages/JobsPage';
import ProfilePage from './pages/ProfilePage';
import EmployeeProfile from './pages/EmployeeProfile';
import CreateJobPage from './pages/CreateJobPage';
import EditJobPage from './pages/EditJobPage';
import JobApplicationsPage from './pages/JobApplicationsPage';
import Skelbimai from './pages/Skelbimai';
import JobSearchPage from './pages/JobSearchPage';
import JobDetailPage from './pages/JobDetailPage';
import CandidateDetailPage from './pages/CandidateDetailPage';
import ManoCV from './pages/ManoCV';
import CVCreateEditPage from './pages/CVCreateEditPage';
import SavedSearches from './pages/SavedSearches';
import SavedJobs from './pages/SavedJobs';
import Kandidatavimas from './pages/Kandidatavimas';
import ManoPaieskos from './pages/ManoPaieskos';
import Atrankos from './pages/Atrankos';
import FolderDetail from './pages/FolderDetail';
import SelectionDetail from './pages/SelectionDetail';
import InvitationLetters from './pages/InvitationLetters';
import Services from './pages/Services';
import Checkout from './pages/Checkout';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import JobInvitations from './pages/JobInvitations';
import EmployeeServices from './pages/EmployeeServices';
import Prenumeratos from './pages/Prenumeratos';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ContactPage from './pages/ContactPage';
import TestimonialsPage from './pages/TestimonialsPage';
import HelpPage from './pages/HelpPage';
import TermsPage from './pages/TermsPage';
import EmployerClients from './pages/EmployerClients';
import FreelanceGigsList from './pages/FreelanceGigsList';
import FreelanceGigCreate from './pages/FreelanceGigCreate';
import FreelanceGigDetail from './pages/FreelanceGigDetail';
import FreelanceBrowse from './pages/FreelanceBrowse';
import FreelanceGigPublic from './pages/FreelanceGigPublic';
import FreelanceMyResponses from './pages/FreelanceMyResponses';
import FreelanceMessages from './pages/FreelanceMessages';
import Pasiulymai from './pages/Pasiulymai';
import EmployerPokalbiai from './pages/EmployerPokalbiai';
import InterviewThread from './pages/InterviewThread';
import PasswordGate from './components/PasswordGate';
import OnboardingGate from './components/Auth/OnboardingGate';
import AISearch from './pages/AISearch';
import './App.scss';

function App() {
  return (
    <PasswordGate>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
    <AuthProvider>
    <ToastProvider>
      <Router>
        <div className="App">
          <RejectionNotices />
          <Layout>
            <OnboardingGate>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/dashboard/employee" element={<EmployeeDashboard />} />
              <Route path="/dashboard/employer" element={<EmployerDashboard />} />
              <Route path="/dashboard/admin" element={<AdminDashboard />} />
              <Route path="/admin" element={<Navigate to="/dashboard/admin" replace />} />
              <Route path="/admin/cvs" element={<AdminCVManagement />} />
              <Route path="/admin/cv-templates" element={<AdminCVTemplateManagement />} />
              <Route path="/admin/service-prices" element={<AdminServicePrices />} />
              <Route path="/admin/companies" element={<AdminCompanyManagement />} />
              <Route path="/jobs" element={<JobsPage />} />
              <Route path="/jobs/create" element={<CreateJobPage />} />
              <Route path="/jobs/edit/:id" element={<EditJobPage />} />
              <Route path="/jobs/:jobId/applications" element={<JobApplicationsPage />} />
              <Route path="/job/:id" element={<JobDetailPage />} />
              <Route path="/skelbimai" element={<Skelbimai />} />
              <Route path="/candidate/:id" element={<CandidateDetailPage />} />
              <Route path="/cv/:id" element={<CandidateDetailPage />} />
              <Route path="/darbo-skelbimai" element={<JobSearchPage />} />
              <Route path="/imones" element={<CompaniesPage />} />
              <Route path="/mano-cv" element={<ManoCV />} />
              <Route path="/cv/create" element={<CVCreateEditPage />} />
              <Route path="/cv/edit/:id" element={<CVCreateEditPage />} />
              {/* Employee Routes */}
              <Route path="/issaugotos-paieskos" element={<SavedSearches />} />
              <Route path="/pazymeti-skelbimai" element={<SavedJobs />} />
              <Route path="/kandidatavimas" element={<Kandidatavimas />} />
              <Route path="/job-invitations" element={<JobInvitations />} />
              <Route path="/employee/services" element={<EmployeeServices />} />
              <Route path="/prenumeratos" element={<Prenumeratos />} />
              
              {/* Employer Routes */}
              <Route path="/employer/searches" element={<ManoPaieskos />} />
              <Route path="/employer/selections" element={<Atrankos />} />
              <Route path="/employer/selections/folder/:id" element={<FolderDetail />} />
              <Route path="/employer/selections/selection/:id" element={<SelectionDetail />} />
              <Route path="/employer/invitation-letters" element={<InvitationLetters />} />
              <Route path="/employer/services" element={<Services />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/return" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/employer/clients" element={<EmployerClients />} />
              <Route path="/employer/candidates" element={<Skelbimai />} />

              {/* Freelance Gigs (Phase 1–6) */}
              <Route path="/freelance/gigs"          element={<FreelanceGigsList />} />
              <Route path="/freelance/gigs/new"      element={<FreelanceGigCreate />} />
              <Route path="/freelance/gigs/:id/edit" element={<FreelanceGigCreate />} />
              <Route path="/freelance/gigs/:id"      element={<FreelanceGigDetail />} />
              <Route path="/freelance/browse"        element={<FreelanceBrowse />} />
              <Route path="/freelance/browse/:id"    element={<FreelanceGigPublic />} />
              <Route path="/freelance/my-responses"  element={<FreelanceMyResponses />} />
              <Route path="/freelance/messages/:respId" element={<FreelanceMessages />} />

              {/* Interview Invitations ("Pakviesti pokalbiui") */}
              <Route path="/pasiulymai"                  element={<Pasiulymai />} />
              <Route path="/pasiulymai/:id"              element={<InterviewThread />} />
              <Route path="/employer/pokalbiai"          element={<EmployerPokalbiai />} />
              <Route path="/employer/pokalbiai/:id"      element={<InterviewThread />} />
              
              {/* Legacy routes - keep for backward compatibility but redirect */}
              <Route path="/mano-paieskos" element={<ManoPaieskos />} />
              <Route path="/atrankos" element={<Atrankos />} />
              <Route path="/atrankos/folder/:id" element={<FolderDetail />} />
              <Route path="/atrankos/selection/:id" element={<SelectionDetail />} />
              <Route path="/atsakymu-laiskai" element={<InvitationLetters />} />
              <Route path="/invitation-letters" element={<InvitationLetters />} />
              <Route path="/pakvietimai" element={<JobInvitations />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/profile/employee" element={<EmployeeProfile />} />
              <Route path="/kontaktai" element={<ContactPage />} />
              <Route path="/atsiliepimai" element={<TestimonialsPage />} />
              <Route path="/pagalba" element={<HelpPage />} />
              <Route path="/naudojimosi-salygos" element={<TermsPage />} />
              <Route path="/ai-paieska" element={<AISearch />} />
            </Routes>
            </OnboardingGate>
          </Layout>
        </div>
      </Router>
    </ToastProvider>
    </AuthProvider>
    </GoogleOAuthProvider>
    </PasswordGate>
  );
}

export default App;
